(() => {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const menus = [...root.querySelectorAll('.nf-mega')];
    menus.forEach(menu => menu.addEventListener('toggle', () => {
      if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
    }));
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        const open = root.querySelector('details[open]');
        if (open) { open.open = false; open.querySelector('summary').focus(); }
      }
    });
    document.addEventListener('click', event => {
      if (!root.contains(event.target)) root.querySelectorAll('details[open]').forEach(menu => { menu.open = false; });
    });
  }
  document.querySelectorAll('[data-nf-header]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nf-header]').forEach(setup));
})();
